// What the File templates grid says about a template's e-signature readiness.
// The backend sends `template.signature = { ready, source, signers, checked }`
// (the same answer the "Send for E-Signature" picker uses).

export const SIGNATURE_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'signable', label: 'Signable' },
  { value: 'not_signable', label: 'Not signable' },
];

const SOURCE_HINTS = {
  boxes: 'Signature boxes placed in WHG Docs. Opens for signing with no setup.',
  tags: 'Signature tags are in the file itself. Opens for signing with no setup.',
  signature_fields: 'The form has a fillable signature field. Opens for signing with no setup.',
};

export const isSignable = (template) => Boolean(template?.signature?.ready);

/**
 * Badge text and tone for a template card, or null when the API sent no
 * signature summary (letterheads, older responses).
 */
export const signatureBadge = (template) => {
  const signature = template?.signature;
  if (!signature || typeof signature !== 'object') return null;
  if (signature.ready) {
    const signers = (signature.signers || []).filter(Boolean);
    return {
      tone: 'signable',
      label: signers.length ? `Signable · ${signers.join(' + ')}` : 'Signable',
      hint: SOURCE_HINTS[signature.source] || 'Ready to send for signature.',
    };
  }
  if (signature.checked === false) {
    return {
      tone: 'muted',
      label: 'Signature check pending',
      hint: 'The file has not been scanned for signature spots yet. It is checked nightly.',
    };
  }
  return {
    tone: 'muted',
    label: 'No signature spots',
    hint: 'Nothing marks where anyone signs. Open the template and add signature spots to make it signable.',
  };
};

export const filterTemplatesBySignature = (templates, filter) => {
  const list = Array.isArray(templates) ? templates : [];
  if (filter === 'signable') return list.filter(isSignable);
  if (filter === 'not_signable') return list.filter((t) => !isSignable(t));
  return list;
};

export const countSignable = (templates) =>
  (Array.isArray(templates) ? templates : []).filter(isSignable).length;
